import { useModal } from "@ebay/nice-modal-react";
import { useState } from "react";

import Button from "ds/components/Button";
import DatepickerRange from "ds/components/Datepicker/Range";
import { DateRange } from "ds/components/Datepicker/types";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerFooterActions from "ds/components/Drawer/FooterActions";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCancelButton from "ds/components/DrawerNew/CancelButton";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import { AspectType } from "types/generated";
import { downloadFileFromURL } from "utils/file";

import { INITIAL_PERIOD, PERIODS } from "./constants";
import {
  getCSVDownloadLink,
  getCSVDownloadMaxDate,
  getCSVDownloadMinDate,
  getCSVDownloadTimeFilter,
  validateCSVDownloadRange,
} from "./utils";

type CSVDownloadDrawerProps = {
  aspectType: AspectType;
};

const CSVDownloadDrawer = createDrawer(({ aspectType }: CSVDownloadDrawerProps) => {
  const drawer = useModal();
  const [dateRange, setDateRange] = useState<DateRange>(PERIODS[INITIAL_PERIOD].range);

  const error = validateCSVDownloadRange(dateRange);

  const handleExport = () => {
    if (error) {
      return;
    }

    downloadFileFromURL(getCSVDownloadLink(aspectType, getCSVDownloadTimeFilter(dateRange)));
    drawer.hide();
  };

  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Export CSV" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <FormField label="Select start to end date" error={error}>
          <DatepickerRange
            startDate={dateRange.start}
            endDate={dateRange.end}
            periods={PERIODS}
            initialPeriod={INITIAL_PERIOD}
            onChange={setDateRange}
            minDate={getCSVDownloadMinDate()}
            maxDate={getCSVDownloadMaxDate()}
            granularity="day"
            hasError={!!error}
            fullWidth
          />
        </FormField>
      </DrawerBody>
      <DrawerFooter>
        <DrawerFooterActions>
          <DrawerCancelButton />
          <Button variant="primary" onPress={handleExport}>
            Export CSV
          </Button>
        </DrawerFooterActions>
      </DrawerFooter>
    </DrawerSimple>
  );
});

export const showCSVDownloadDrawer = createDrawerTrigger(CSVDownloadDrawer);
